// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2822svcuzB3-pMfK8euGlE","triangleStyles":"_2usZetH1TfTqxIl5DRcyFx"};